import { useRouter } from 'react-resource-router';

import { useAppData } from 'src/app/data';
import { useHistory__UNSAFE, useParams } from 'src/router/hooks';
import { getRouteFeaturesFromAppData } from 'src/router/utils/route-features';
import IframeWrapped from 'src/sections/repository/components/iframe-wrapped';

import SourceBrowser, { Params } from './source-browser';
import SourceSection from './source-section';

const SourceBrowserWrapped = () => {
  const [router] = useRouter();
  const history = useHistory__UNSAFE();
  const params = useParams<Params>();
  const appData = useAppData();
  const routeFeatures = getRouteFeaturesFromAppData(appData);

  if (
    routeFeatures.isRepoSourceFileEditEnabled &&
    router.query.mode === 'edit'
  ) {
    return <IframeWrapped />;
  }

  return (
    <SourceSection {...router} {...params} history={history}>
      <SourceBrowser {...router} {...params} history={history} />
    </SourceSection>
  );
};

export default SourceBrowserWrapped;
